<template>
  <Chat />
</template>

<script setup lang="ts">
import Chat from '@/components/chat/Chat.vue'
import { usePromptsStore } from '@/stores/promptsStore'
import { useLocaleStore } from '@/stores/localeStore'
import { useCategoriesStore } from '@/stores/categoriesStore'

// Register stores
useLocaleStore()
usePromptsStore()
useCategoriesStore()
</script>
